/* eslint-disable react/jsx-props-no-spreading */
import styled from '@emotion/styled';
import { FC, ReactNode } from 'react';

type StyledDivProps = {
  $orientation: string;
  $borderRadius: string;
};

const StyledDiv = styled.div<StyledDivProps>`
  height: ${({ $orientation }) => $orientation === 'vertical' && '152px'};
  width: 272px;
  object-fit: cover;
  position: relative;
  background-color: var(--color-divider);
  border-radius: ${({ $borderRadius }) => $borderRadius};
  overflow: hidden;
`;

type ThumbnailProps = {
  orientation?: 'horizontal' | 'vertical';
  className?: string;
  onClick?: (...args: any[]) => any;
  children?: ReactNode;
  borderRadius?: string;
};

const Thumbnail: FC<ThumbnailProps> = ({
  orientation = 'vertical',
  className = '',
  children = null,
  onClick = () => {},
  borderRadius = '0px',
  ...props
}) => {
  return (
    <StyledDiv
      $orientation={orientation}
      className={`${className} batch-thumbnail`}
      onClick={onClick}
      $borderRadius={borderRadius}
      {...props}
    >
      {children}
    </StyledDiv>
  );
};

export default Thumbnail;
